export default __webpack_public_path__ + "static/media/play-audio.12587f06.svg";